<template>
  <div v-if="assignment" class="mx-auto lg:w-1/2 w-full">
    <vx-card class="mb-base">
      <div class="mb-base">
        <h4>
          {{assignment.title}}
          <span class="ml-2 text-gray">({{assignment.mark}} درجة)</span>
        </h4>
        <p class="flex items-center mt-2 text-gray">
          <feather-icon svg-classes="h-4 w-4" icon="CalendarIcon" />
          <span class="mx-2">تاريخ التسليم</span>
          <span>{{assignment.deadline}}</span>
        </p>
      </div>
      <text-editor-viewer :data="assignment.body" />
    </vx-card>

    <vs-alert v-if="!answer" class="mb-base" color="danger">لم تقم بتسليم الواجب</vs-alert>
    <vs-alert v-else-if="answer.mark === undefined" class="mb-base" active="true">
      لم يقم الاستاذ برصد درجات الواجب بعد، قم بالتحقق لاحقاً.
    </vs-alert>

    <vx-card v-if="answer" class="mb-base" title="الإجابة">
      <div slot="actions">
        <div class="px-4 py-2 rounded-full bg-primary text-white">
          <span class="font-bold">{{assignment.mark}} / </span>
          <span class="text-xl">{{typeof answer.mark === 'number' ? answer.mark : '*'}}</span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full mb-4">
          <text-editor-viewer :data="answer.body" />
        </div>
        <div v-if="answer.file.path" class="vx-col w-full mt-8 mb-4">
          <file :name="answer.file.name"
                :size="answer.file.size"
                :path="answer.file.path" />
        </div>
        <div v-if="answer.teacher_comment" class="vx-col w-full mb-4">
          <h4>ملاحظة</h4>
          <p>{{answer.teacher_comment}}</p>
        </div>
      </div>

    </vx-card>
  </div>
</template>

<script>
    import assignmentsAPI from '@/api/assignmentsAPI'
    import TextEditorViewer from '@/views/components/TextEditorViewer'

    export default {
        name: "AssignmentResult.vue",
      components: { TextEditorViewer },
      data() {
            return {
                assignment: null,
                answer: {},
            }
        },
        beforeRouteEnter(to, from, next){
            assignmentsAPI.setCourseId(to.params.course_id)
            assignmentsAPI.getById(to.params.assignment_id)
                .then(({data}) => {
                    next(vm => {
                        vm.assignment = data.assignment
                        vm.answer = Array.isArray(data.answer) ? null : data.answer
                    })
                })
        },
    }
</script>
